import React, { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import { number, object, string, date, array } from "yup";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CaseServices } from "../../../services/CaseServices";
import { PreinitiateServices } from "../../../services/PreinitiateServices";
import ImagesGalleryHospitalPersona from "../../../hospitalPersona/imageGallery/ImageGalleryHospitalPersona";
import AddCaseProcedure from "./AddCaseProcedure";
import { useSelector } from "react-redux";
import "./AddCaseDetails.scss";
import PersonalHistoryModal from "../casedetails/PersonalHistoryModal";
import FamilyHistoryModal from "../casedetails/FamilyHistoryModal";
import GeneralFindingsModal from "../casedetails/GeneralFindingsModal";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import CloseIcon from "../../../assets/crossIcon.svg";
import PdfIcon from "../../../assets/pdfIcon.png";
import ReuploadImageIcon from "../../../assets/reUploadImageIcon.png";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { PatientServices } from "../../../services/PatientServices";
import { CircularProgress, Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ECTDiagnosisSearch from "../../../ICD/DiagnosisSearch";
import SearchIcon from "@mui/icons-material/Search";
import ReferenceDocFlow from "./ReferenceDocFlow";
import PatientInfo from "../editCases/PatientInfo";
import { Label } from "@mui/icons-material";

const AddCaseDetails = ({
  setValue,
  setCaseId,
  patientId,
  functionalityType,
  caseDetails,
  refreshPage,
  hospitalid,
  patientDetails,
  setPatientDetails,
  setPatientId,
}) => {
  const [updated, setUpdated] = useState(false); // to refresh the page
  const [referenceDocuments, setReferenceDocuments] = useState(null);
  const [groupedReferenceDocuments, setGroupedReferenceDocuments] =
    useState(null);
  const [documentType, setDocumentType] = useState("ADMISSIONDOCUMENT");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [referencePendingModal, setReferencePendingModal] = useState(false);
  const [admissionPreApprovedModal, setAdmissionPreApprovedModal] =
    useState(false);
  const [reason, setReason] = useState("");
  const [preApprovedRemark, setPreApprovedRemark] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [openDiagnosisSearch, setOpenDiagnosisSearch] = useState(false);
  const [primary, setPrimary] = useState(true);
  const [primaryDiagnosisDetails, setPrimaryDiagnosisDetails] = useState(
    caseDetails?.primaryDiagnosisDetails,
  );
  const [secondaryDiagnosisDetails, setSecondaryDiagnosisDetails] = useState(
    caseDetails?.secondaryDiagnosisDetails,
  );
  const navigate = useNavigate();
  const addProcedure = (push) => {
    push({
      speciality: "",
      procedureId: "",
      ichiCode: "",
      stratification: "",
      implants: "",
      doctorName: "",
      specialityId: "",
      compositId: "",
      state: caseDetails?.hospital?.state,
    });
  };
  let initialValues;

  {
    functionalityType === "EDIT"
      ? (initialValues = {
          primaryDiagnosisDetails:
            caseDetails?.primaryDiagnosisDetails?.value ||
            caseDetails?.primaryDiagnosis?.value ||
            caseDetails?.primaryDiagnosis,
          secondaryDiagnosisDetails:
            caseDetails?.secondaryDiagnosisDetails?.value ||
            caseDetails?.secondaryDiagnosis,
          admissionType: caseDetails?.admissionType,
          admissionDate:
            caseDetails?.admissionDate &&
            caseDetails?.admissionDate.split("T")[0],
          surgeryTreatmentStartDate:
            caseDetails?.surgeryTreatmentStartDate &&
            caseDetails?.surgeryTreatmentStartDate.split("T")[0],
          medicoLegalCase: caseDetails?.medicoLegalCase || "No",
          fir: caseDetails?.fir,
          policeStationName: caseDetails?.policeStationName,
          packageCost: caseDetails?.packageCost,
          totalPackageCost: caseDetails?.totalPackageCost,
          caseType: caseDetails?.caseType,
          approvedForAdmission: caseDetails?.approvedForAdmission,
          wardByHospital: caseDetails?.wardByHospital,
          admissionDateByHospital:
            caseDetails?.admissionDateByHospital?.split("T")[0],
          lengthOfStay: caseDetails?.lengthOfStay,
          caseProcedures: caseDetails?.caseprocedures?.map((procedure) => ({
            ...procedure,
            state: caseDetails?.hospital?.state,

            implants: procedure.implants ?? "",
            stratification: procedure.stratification ?? "",
            packageCost: procedure.packageCost,
          })),
          pmjayId: caseDetails?.pmjayId,
          pmjayRegistrationId: caseDetails?.pmjayRegistrationId,
          carePlan: caseDetails?.carePlan || "",
          primaryDiagnosisICDcode: caseDetails?.primaryDiagnosisDetails?.code,
          secondaryDiagnosisICDcode:
            caseDetails?.secondaryDiagnosisDetails?.code,
        })
      : (initialValues = {
          primaryDiagnosisDetails: "",
          primaryDiagnosisICDcode: "",
          secondaryDiagnosisDetails: "",
          secondaryDiagnosisICDcode: "",
          admissionType: "",
          admissionDate: "",
          medicoLegalCase: "No",
          fir: "",
          pmjayId: "",
          pmjayRegistrationId: "",
          carePlan: "",
          policeStationName: "",
          // packageCost: "",
          totalPackageCost: "",
          caseType: "",
          approvedForAdmission: null,

          caseProcedures: [
            {
              speciality: "",
              specialityId: "",
              procedure: "",
              procedureId: "",
              CompositId: "",
              procedureType: "",
              compositId: "",
              ichiCode: "",
              tierCost: "",
              tier: "",
              stratification: "",
              implants: "",
              doctorName: "",
              doctorId: "",
              packageCost: "",
              state: caseDetails?.hospital?.state,
            },
          ],
        });
  }

  const errorValidation = object({
    primaryDiagnosisDetails: string().required("Required Field"),
    // secondaryDiagnosis: string().required("Required Field"),
    admissionType: string().required("Required Field"),
    caseType: string().required("Required Field"),
    // carePlan: string().required("Required Field"),

    admissionDate: date().required("Required Field"),
    // fir: string().required("Required Field"),
    // policeStationName: string().required("Required Field"),
    // packageCost: number().required("Required Field"),
    totalPackageCost: number().required("Required Field"),
    caseProcedures: array().of(
      object({
        speciality: string().required("Required Field"),
        procedure: string().required("Required Field"),
        // ichiCode: string().required("Required Field"),
        // stratification: string().required("Required Field"),
        // doctorName: string().required("Required Field"),
        implants: string().when("availableImplants", {
          is: (val) => Array.isArray(val) && val.length > 0,
          then: (schema) => schema.required("Required Field"),
          otherwise: (schema) => schema.notRequired(),
        }),
        availableImplants: array().default([]),

        packageCost: number().required("Required Field"),
      }),
    ),
  });

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      let caseRes = await CaseServices.addNewCase({
        ...values,
        primaryDiagnosisDetails: primaryDiagnosisDetails,
        secondaryDiagnosisDetails: secondaryDiagnosisDetails,
        patientId: patientId,
        hospitalId: hospitalid,
        status: "CASEADDED",
      });
      setCaseId(caseRes?.data?.caseId);
      await CaseServices.addCaseProcedure(
        values.caseProcedures,
        caseRes?.data?.caseId,
      );
      window.alert("Case Details saved");
      setValue("MAP DOCUMENTS");
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };

  const handleUpdate = async (values) => {
    setIsSubmitting(true);
    try {
      await CaseServices.updateCase(
        {
          ...values,
          primaryDiagnosisDetails: primaryDiagnosisDetails,
          secondaryDiagnosisDetails: secondaryDiagnosisDetails,
        },
        caseDetails?.id,
      );
      await CaseServices.updateCaseProcedures(
        values.caseProcedures,
        caseDetails?.id,
      );
      await refreshPage();
      window.alert("Case Details updated");
      setValue("MAP DOCUMENTS");
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };
  const handleStatusChange = async () => {
    setIsLoading(true);
    if (reason) {
      try {
        const postStageData = {
          hsaStage: "Reference Document Pending",
          commandCeneterStage: "Reference Document Pending",
          nextStepUser: "Hospital Sub Admin (HSA)",
        };
        const stageResponse = await CaseServices.updateSubMasterStage(
          caseDetails.id,
          postStageData,
        );
        window.alert(stageResponse.data.message);
        setReferencePendingModal(false);

        navigate("/dashboard/ActiveCases");
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("Reason is Required");
    }
    setIsLoading(false);
  };
  const handlePreApproveAdmission = async (setFieldValue, values) => {
    if (preApprovedRemark) {
      const data = {
        approvedForAdmission: values?.approvedForAdmission,
        preApprovalRemark: preApprovedRemark,
      };
      try {
        const response = await CaseServices.handlePreApprovedAdmission(
          caseDetails.id,
          data,
        );
        window.alert(response?.data?.message);
        setFieldValue("approvedForAdmission", "true");
        setAdmissionPreApprovedModal(false);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("Please add remark");
    }
  };
  const handlePreRejectionAdmission = async (setFieldValue, values) => {
    const data = {
      approvedForAdmission: false,
      preApprovalRemark: "Admission Rejected",
    };
    try {
      const response = await CaseServices.handlePreApprovedAdmission(
        caseDetails.id,
        data,
      );
      window.alert(response?.data?.message);
      setAdmissionPreApprovedModal(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  async function getPatientDetails(patientId) {
    try {
      let res = await PatientServices.getPatientDetails(patientId);
      if (res?.data?.patient) setPatientDetails(res?.data?.patient);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  }
  const getDocumentsData = async () => {
    setIsLoading(true);

    try {
      const response = await PreinitiateServices.getReferenceDocuments(
        caseDetails?.id,
        documentType,
      );

      let tempData = response.data;
      let modifiedData = [];
      let groupedDocs = [];
      let rejectedDocCount = 0;

      for (let doc of tempData) {
        if (doc.parentId) {
          if (groupedDocs.length === 0) {
            groupedDocs.push(doc);
            rejectedDocCount =
              doc?.status === "REJECTED"
                ? rejectedDocCount + 1
                : rejectedDocCount;
          } else {
            if (doc.parentId === groupedDocs[0].parentId) {
              groupedDocs.push(doc);
              rejectedDocCount =
                doc?.status === "REJECTED"
                  ? rejectedDocCount + 1
                  : rejectedDocCount;
            } else {
              modifiedData.push({
                parentId: groupedDocs[0].parentId,
                docs: groupedDocs,
                rejectedDocCount: rejectedDocCount,
              });
              groupedDocs = [];

              groupedDocs.push(doc);
              rejectedDocCount = doc?.status === "REJECTED" ? 1 : 0;
            }
          }
        } else {
          rejectedDocCount = doc?.status === "REJECTED" ? 1 : 0;
          modifiedData.push({
            parentId: null,
            docs: [doc],
            rejectedDocCount: rejectedDocCount,
          });
        }
      }

      // Ensure to add remaining grouped docs
      if (groupedDocs.length > 0) {
        modifiedData.push({
          parentId: groupedDocs[0].parentId,
          docs: groupedDocs,
          rejectedDocCount: rejectedDocCount,
        });
      }
      setReferenceDocuments(response.data);
      setGroupedReferenceDocuments(modifiedData);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    if (functionalityType === "EDIT") getPatientDetails(patientId);
  }, [updated]);
  useEffect(() => {
    getDocumentsData();
  }, [documentType]);
  useEffect(() => {
    if (functionalityType === "EDIT") {
      console.log(
        "Primary diagnosis details:",
        caseDetails?.primaryDiagnosisDetails,
      );
      // Keep form state in sync when diagnosis is updated from Update Documents
      if (caseDetails?.primaryDiagnosisDetails) {
        setPrimaryDiagnosisDetails(caseDetails.primaryDiagnosisDetails);
      }
    }
  }, [caseDetails?.primaryDiagnosisDetails]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={errorValidation}
        onSubmit={functionalityType === "EDIT" ? handleUpdate : handleSubmit}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="add-case-container">
            <PatientInfo
              patientDetails={patientDetails}
              caseDetails={{
                ...values,
                primaryDiagnosisDetails: primaryDiagnosisDetails,
                secondaryDiagnosisDetails: secondaryDiagnosisDetails,
                caseSubType: caseDetails?.caseSubType,
              }}
            />
            <div>
              <div className="heading">
                {functionalityType === "EDIT" ? "Edit " : ""}Case Details
              </div>

              <div>
                <Accordion style={{ borderRadius: "16px" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <div className="font-semibold">Reference Documents</div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ReferenceDocFlow
                      caseDetails={caseDetails}
                      isScreenshot={false}
                    />
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
            <div className="case-form-container1">
              <label className="label1">
                <div className="text-content">Primary Diagnosis *</div>
                <div className="flex gap-2">
                  <Field
                    className="input-field w-[95%]"
                    name="primaryDiagnosisDetails"
                    placeholder="Primary Diagnosis"
                    onChange={(e) => {
                      setFieldValue("primaryDiagnosisDetails", e.target.value);
                      setPrimaryDiagnosisDetails({
                        ...primaryDiagnosisDetails,
                        value: e.target.value,
                      });
                    }}
                  />
                  <span onClick={() => setOpenDiagnosisSearch(true)}>
                    <div
                      className="flex items-center justify-center h-full cursor-pointer"
                      onClick={() => {
                        setOpenDiagnosisSearch(true);
                        setPrimary(true);
                      }}
                    >
                      <SearchIcon style={{ color: "black" }} />
                    </div>
                  </span>
                </div>
                {touched.primaryDiagnosisDetails &&
                  errors.primaryDiagnosisDetails && (
                    <div className="field-error">
                      {errors.primaryDiagnosisDetails}
                    </div>
                  )}
              </label>
              <label className="label1">
                <div className="text-content">Primary Diagnosis ICD Code</div>
                <div className="flex gap-2">
                  <Field
                    className="input-field w-[95%]"
                    name="primaryDiagnosisICDcode"
                    placeholder="Primary Diagnosis ICD Code"
                    onChange={(e) => {
                      setFieldValue("primaryDiagnosisICDcode", e.target.value);
                    }}
                  />
                </div>
                {touched.primaryDiagnosisDetails &&
                  errors.primaryDiagnosisDetails && (
                    <div className="field-error">
                      {errors.primaryDiagnosisDetails}
                    </div>
                  )}
              </label>
              {openDiagnosisSearch && (
                <ECTDiagnosisSearch
                  setOpen={setOpenDiagnosisSearch}
                  setFieldValue={setFieldValue}
                  setPrimaryDiagnosisDetails={setPrimaryDiagnosisDetails}
                  setSecondaryDiagnosisDetails={setSecondaryDiagnosisDetails}
                  primary={primary}
                />
              )}
              <label className="label1">
                <div className="text-content">Secondary Diagnosis</div>
                <div className="flex gap-2">
                  <Field
                    className="input-field w-[95%]"
                    name="secondaryDiagnosisDetails"
                    placeholder="Secondary Diagnosis"
                    onChange={(e) => {
                      setFieldValue(
                        "secondaryDiagnosisDetails",
                        e.target.value,
                      );
                      setSecondaryDiagnosisDetails({
                        ...secondaryDiagnosisDetails,
                        value: e.target.value,
                      });
                    }}
                  />
                  <span
                    onClick={() => {
                      setOpenDiagnosisSearch(true);
                      setPrimary(false);
                    }}
                  >
                    <div
                      className="flex items-center justify-center h-full cursor-pointer"
                      onClick={() => setOpenDiagnosisSearch(true)}
                    >
                      <SearchIcon style={{ color: "black" }} />
                    </div>
                  </span>
                </div>
                {touched.secondaryDiagnosis && errors.secondaryDiagnosis && (
                  <div className="field-error">{errors.secondaryDiagnosis}</div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Secondary Diagnosis ICD Code</div>
                <div className="flex gap-2">
                  <Field
                    className="input-field w-[95%]"
                    name="secondaryDiagnosisICDcode"
                    placeholder="Secondary Diagnosis ICD Code"
                    onChange={(e) =>
                      setFieldValue("secondaryDiagnosisICDcode", e.target.value)
                    }
                  />
                </div>
                {touched.secondaryDiagnosisICDcode &&
                  errors.secondaryDiagnosisICDcode && (
                    <div className="field-error">
                      {errors.secondaryDiagnosisICDcode}
                    </div>
                  )}
              </label>
            </div>
            <FieldArray name="caseProcedures">
              {({ insert, remove, push }) => (
                <div>
                  {values &&
                    values.caseProcedures &&
                    values.caseProcedures.map((procdure, idx) => {
                      return (
                        <div key={idx}>
                          <hr
                            style={{
                              color: "#E4E4E4",
                              marginTop: "40px",
                              width: "100%",
                            }}
                          />
                          <AddCaseProcedure
                            errors={errors}
                            touched={touched}
                            index={idx}
                            procdure={procdure}
                            setFieldValue={setFieldValue}
                            patientDetails={patientDetails}
                            values={values}
                            remove={remove}
                            addProcedure={addProcedure}
                            hospitalState={caseDetails?.hospital?.state}
                            caseDetails={caseDetails}
                          />
                        </div>
                      );
                    })}
                  <div className="button-box">
                    <button
                      type="button"
                      className="fill-btn"
                      style={{
                        width: "max-content",
                        paddingInline: "32px",
                        cursor: "pointer",
                      }}
                      onClick={() => addProcedure(push)}
                    >
                      <AddOutlinedIcon style={{ height: "14px" }} />
                      ADD PROCEDURE {values?.caseProcedures.length + 1}
                    </button>
                  </div>
                </div>
              )}
            </FieldArray>

            <hr
              style={{ color: "#E4E4E4", marginTop: "40px", width: "100%" }}
            />
            <div className="block xl:flex mt-[40px] gap-[8px]">
              <GeneralFindingsModal
                patientId={patientId}
                patientDetails={patientDetails}
                setUpdated={setUpdated}
                updated={updated}
                functionalityType={functionalityType}
              />
              <PersonalHistoryModal
                patientId={patientId}
                patientDetails={patientDetails}
                setUpdated={setUpdated}
                updated={updated}
                functionalityType={functionalityType}
              />
              <FamilyHistoryModal
                patientId={patientId}
                patientDetails={patientDetails}
                setUpdated={setUpdated}
                updated={updated}
                functionalityType={functionalityType}
              />
            </div>
            <div className="case-form-container1 items-center">
              <label className="label1">
                <div className="text-content">Case Type *</div>
                <Field className="input-field" name="caseType" as="select">
                  <option>Case Type</option>
                  <option value="SURGICAL">SURGICAL</option>
                  <option value="CONSERVATIVE">CONSERVATIVE</option>
                  <option value="DAYCARE">DAYCARE</option>
                </Field>
                {touched.caseType && errors.caseType && (
                  <div className="field-error">{errors.caseType}</div>
                )}
              </label>
              {values?.caseType === "CONSERVATIVE" && (
                <label className="label1">
                  <div className="text-content">Ward By Hospital</div>
                  <Field
                    className="input-field"
                    name="wardByHospital"
                    // as="select"
                    disabled
                  />
                  {/* {touched.caseType && errors.caseType && (
                  <div className="field-error">{errors.caseType}</div>
                )} */}
                </label>
              )}
              {values?.caseType === "CONSERVATIVE" && (
                <label className="label1">
                  <div className="text-content">Stay Duration</div>
                  <Field
                    className="input-field"
                    name="lengthOfStay"
                    as="select"
                    disabled
                  >
                    <option>Stay Duration</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="More Than 9">More Than 9</option>
                  </Field>
                  {/* {touched.caseType && errors.caseType && (
                  <div className="field-error">{errors.caseType}</div>
                )} */}
                </label>
              )}
              <label className="label1">
                <div className="text-content">Admisssion Date By Hospital</div>
                {/* <Field
                  className="input-field"
                  name="admissionDateByHospital"
                  // as="select"
                  disabled
                /> */}
                <Field
                  className="input-field"
                  name="admissionDateByHospital"
                  placeholder="Admission Date"
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  min={
                    new Date(new Date().setDate(new Date().getDate() - 60))
                      .toISOString()
                      .split("T")[0]
                  }
                  disabled
                />
                {/* {touched.caseType && errors.caseType && (
                  <div className="field-error">{errors.caseType}</div>
                )} */}
              </label>
              <label className="label1">
                <div className="text-content">Admission Type *</div>
                <Field className="input-field" name="admissionType" as="select">
                  <option>Admission Type</option>
                  <option value="EMERGENCY">EMERGENCY</option>
                  <option value="PLAN">PLANNED</option>
                </Field>
                {touched.admissionType && errors.admissionType && (
                  <div className="field-error">{errors.admissionType}</div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Admission Date *</div>
                <Field
                  className="input-field"
                  name="admissionDate"
                  placeholder="Admission Date"
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  min={
                    new Date(new Date().setDate(new Date().getDate() - 60))
                      .toISOString()
                      .split("T")[0]
                  }
                />
                {touched.admissionDate && errors.admissionDate && (
                  <div className="field-error">{errors.admissionDate}</div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Surgery Treatment Date</div>

                <Field
                  className="input-field"
                  name="surgeryTreatmentStartDate"
                  placeholder="Surgery Treatment Date"
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  min={
                    new Date(new Date().setDate(new Date().getDate() - 60))
                      .toISOString()
                      .split("T")[0]
                  }
                  disabled
                />
              </label>
              <label className="label1">
                <div className="text-content">Medico Legal Case</div>
                <div className="flex gap-5 items-center">
                  <div className="flex items-center gap-2">
                    <Field
                      type="radio"
                      id="Yes"
                      name="medicoLegalCase"
                      value="Yes"
                    />
                    <label htmlFor="Yes">Yes</label>
                  </div>
                  <div className="flex items-center gap-2">
                    <Field
                      type="radio"
                      id="No"
                      name="medicoLegalCase"
                      value="No"
                    />
                    <label htmlFor="No">No</label>
                  </div>
                </div>
                {touched.medicoLegalCase && errors.medicoLegalCase && (
                  <div className="field-error">{errors.medicoLegalCase}</div>
                )}
              </label>
              {values?.medicoLegalCase === "Yes" && (
                <label className="label1">
                  <div className="text-content">FIR/MLC</div>
                  <Field
                    className="input-field"
                    name="fir"
                    placeholder="FIR/MLC"
                    type="text"
                  />
                  {touched.fir && errors.fir && (
                    <div className="field-error">{errors.fir}</div>
                  )}
                </label>
              )}
              {values?.medicoLegalCase === "Yes" && (
                <label className="label1">
                  <div className="text-content">Police Station Name</div>
                  <Field
                    className="input-field"
                    name="policeStationName"
                    placeholder="Police Station Name"
                    type="text"
                  />
                  {touched.policeStationName && errors.policeStationName && (
                    <div className="field-error">
                      {errors.policeStationName}
                    </div>
                  )}
                </label>
              )}
              <label className="label1">
                <div className="text-content">Total Package Cost *</div>
                <Field
                  className="input-field"
                  name="totalPackageCost"
                  disabled
                  placeholder="Total Package Cost"
                  type="text"
                  value={values.totalPackageCost}
                />
                {touched.totalPackageCost && errors.totalPackageCost && (
                  <div className="field-error">{errors.totalPackageCost}</div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Pmjay ID</div>
                <Field
                  className="input-field"
                  name="pmjayId"
                  placeholder="Enter pmjay ID"
                  type="text"
                  value={values.pmjayId}
                  maxLength={20}
                  minLength={20}
                />
                {touched.pmjayId && errors.pmjayId && (
                  <div className="field-error">{errors.pmjayId}</div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Pmjay Registration ID</div>
                <Field
                  className="input-field"
                  name="pmjayRegistrationId"
                  placeholder="Enter pmjay registration ID"
                  type="text"
                  value={values.pmjayRegistrationId}
                  maxLength={20}
                  minLength={10}
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 20);
                    setFieldValue("pmjayRegistrationId", value);
                  }}
                />
                {touched.pmjayRegistrationId && errors.pmjayRegistrationId && (
                  <div className="field-error">
                    {errors.pmjayRegistrationId}
                  </div>
                )}
              </label>
              <label className="label1">
                <div className="text-content">Care Plan</div>
                <Field
                  className="input-field"
                  name="carePlan"
                  placeholder="Care Plan"
                  type="text"
                  // value={values.pmjayRegistrationId}
                  // maxLength={20}
                  // minLength={10}
                  // onChange={(e) => {
                  //   const value = e.target.value
                  //     .replace(/\D/g, "")
                  //     .slice(0, 20);
                  //   setFieldValue("pmjayRegistrationId", value);
                  // }}
                />
                {touched.carePlan && errors.carePlan && (
                  <div className="field-error">{errors.carePlanS}</div>
                )}
              </label>
              {caseDetails?.hospital?.preAdmissionApproval?.toLowerCase() ===
                "active" && (
                <label className="flex items-center gap-2 mt-2">
                  {" "}
                  <Field
                    type="checkbox"
                    name="approvedForAdmission"
                    className="w-[20px] h-[20px]"
                    onClick={() => setAdmissionPreApprovedModal(true)}
                  />
                  <div className="text-content font-semibold">
                    Admission Pre-Approved
                  </div>
                </label>
              )}
              {/* {caseDetails?.hospital?.preAdmissionApproval?.toLowerCase() ===
                "active" && (
                <div
                  className="text-sm font-semibold h-fit text-[#D32F2F] bg-white border border-solid border-[#D32F2F] px-5 py-2 rounded-full mt-1 cursor-pointer"
                  onClick={() => {
                    if (window.confirm("Are you sure you want to reject.")) {
                      handlePreRejectionAdmission(setFieldValue, values);
                    }
                  }}
                >
                  Admission Pre-Rejected
                </div>
              )} */}
              {admissionPreApprovedModal && values.approvedForAdmission && (
                <div className="fixed w-screen h-screen top-0 left-0 bg-[#017C5780] flex justify-center items-center z-[1200]">
                  <div className="relative w-[50%] h-fit pb-4 bg-[white] rounded-[16px]">
                    <div
                      className="absolute top-4 right-4 cursor-pointer"
                      onClick={() => {
                        setAdmissionPreApprovedModal(false);
                        setFieldValue("approvedForAdmission", false);
                      }}
                    >
                      <img src={CloseIcon} alt="cross-icon" />
                    </div>
                    <div className="text-xl text-[#191919] text-center font-medium mt-5">
                      Change Pre-Admission Status
                    </div>
                    <div className="flex justify-center gap-4 mt-5">
                      <div className="text-[#191919] font-medium">
                        Please Add Remark *
                      </div>
                      <textarea
                        className="w-[60%] h-[90px] rounded-[8px] p-2"
                        onChange={(e) => setPreApprovedRemark(e.target.value)}
                      />
                    </div>
                    <div className="flex justify-center">
                      <div
                        className="text-sm text-white bg-[#017C57] font-semibold rounded-full px-8 py-2 mt-8 cursor-pointer"
                        onClick={() =>
                          handlePreApproveAdmission(setFieldValue, values)
                        }
                      >
                        Change Status
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-center items-center gap-2 mt-4">
              <div className="">
                {isSubmitting ? (
                  <div className="flex justify-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    style={{ border: "1px solid #017C57" }}
                    className="text-sm text-white font-semibold bg-[#017C57] px-8 py-2 rounded-full"
                  >
                    SAVE AND PROCEED
                  </button>
                )}
              </div>
              <div
                style={{ border: "1px solid #D32F2F" }}
                className="flex items-center gap-2 text-sm text-white bg-[#D32F2F] font-semibold uppercase px-8 py-2 rounded-full cursor-pointer"
                title="Change Case Stage to Reference Document Pending"
                onClick={() => setReferencePendingModal(true)}
              >
                <NewReleasesOutlinedIcon /> Reference Documents Pending
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {referencePendingModal && (
        <div className="fixed w-screen h-screen top-0 left-0 bg-[#017C5780] flex justify-center items-center z-[1200]">
          <div className="relative w-[50%] h-[50%] 2xl:h-[30%] bg-[white] rounded-[16px]">
            <div
              className="absolute top-4 right-4 cursor-pointer"
              onClick={() => setReferencePendingModal(false)}
            >
              <img src={CloseIcon} alt="cross-icon" />
            </div>
            <div className="text-xl text-[#191919] text-center font-medium mt-5">
              Change Case Status
            </div>
            <div className="flex justify-center gap-4 mt-5">
              <div className="text-[#191919] font-medium">
                Please Specify Reason *
              </div>
              <textarea
                className="w-[60%] h-[90px] rounded-[8px] p-2"
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
            <div className="flex justify-center">
              <div
                className="text-sm text-white bg-[#017C57] font-semibold rounded-full px-8 py-2 mt-8 cursor-pointer"
                onClick={handleStatusChange}
              >
                Change Status
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCaseDetails;
